import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import DefaultPage from './Pages/DefaultPage';
import WizardPage from './Pages/WizardPage';

const ChecklistDashboardRouter = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/:cobrandId/wizard`}>
                <WizardPage />
            </Route>
            <Route path={`${path}/wizard`}>
                <WizardPage />
            </Route>
            <Route>
                <DefaultPage />
            </Route>
        </Switch>
    );
};

export default ChecklistDashboardRouter;
